import { Route, Routes, useLocation, useNavigate } from "react-router";
import { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Modal } from "react-bootstrap";
import { QuestionOutlined } from "@ant-design/icons";
import { red } from "@ant-design/colors";
import "antd/dist/antd.min.css";
import "./App.css";
import "./Responsive.css";
import Routing from "./routing/Routing";
import { statusOfOrderDataValue } from "./redux/actions/merchantAction";
import { setupInterceptors } from "./utils/ApiClient";
// import Header from "./pages/landingpages/components/Header/Header";
// import ScrollToTop from "./pages/landingpages/components/ScrollToTop/ScrollToTop";
// import TopBar from "./pages/landingpages/components/TopBar/TopBar";
// import HomePage from "./pages/landingpages/HomePage";
// import PaymentProcessing from "./pages/landingpages/PaymentProcessing";
// import AgentApplication from "./pages/landingpages/AgentApplication";
// import Industries from "./pages/landingpages/Industries";
// import RetailPos from "./pages/landingpages/RetailPos";
// import LossPrevension from "./pages/landingpages/LossPrevension";
// import MerchantApplication from "./pages/landingpages/MerchantApplication";
// import Contact from "./pages/landingpages/Contact";
// import Footer from "./pages/landingpages/components/Footer/Footer";

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isOrderDataAvailable = useSelector(
    (store) => store.merchantReducer.isOrderValue,
  );
  useEffect(() => {
    setupInterceptors(navigate);
  }, [navigate]);
  useEffect(() => {
    const isPurchasePage = location.pathname.includes("purchase-order");
    if (!isPurchasePage && isOrderDataAvailable) {
      setIsModalOpen(true);
    }
  }, [location?.pathname, isOrderDataAvailable]);
  const handleStayOnPage = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const handleDiscardAndLeave = useCallback(() => {
    dispatch(statusOfOrderDataValue(false));
    setIsModalOpen(false);
  }, [dispatch]);

  return (
    <div className="App">
      <Routing />
      <Modal
        size="lg"
        show={isModalOpen}
        onHide={handleStayOnPage}
        aria-labelledby="example-modal-sizes-title-lg contained-modal-title-vcenter"
        centered
        className="modal-dialog-centered"
      >
        <div>
          <Modal.Header className="handle" closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              Confirmation Modal
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="col-md-12">
              <div className="box-img-center add">
                <QuestionOutlined style={{ color: red[5] }} />
              </div>
              <div className="col-md-12 text-oncenter">
                <h5>Are you sure you want to leave this page?</h5>
              </div>
            </div>
            <div className="confirmation-actions">
              <button
                type="button"
                className="vik-button vik-button-primary"
                onClick={handleDiscardAndLeave}
              >
                Yes, Leave
              </button>

              <button
                type="button"
                className="vik-button vik-button-secondary"
                onClick={handleStayOnPage}
              >
                Stay Here
              </button>
            </div>
          </Modal.Body>
        </div>
      </Modal>
    </div>
  );
}
export default App;
